module.exports = __webpack_public_path__ + "img/6.15eed43c.png";